<template>
    <div class="car-quote-step select-coverage">
        <quote-step-header
            :key="currentSubStep"
            :subtitle="subStepFields.subtitle"
            :title="subStepFields.title"
        ></quote-step-header>

        <form class="quote-form" @submit.prevent="next">
            <div class="form-row center sm:my-6">
                <div class="start-insurance-date">
                    <div class="mb-12">
                        <app-label>
                            {{ trans("date_label") }}
                        </app-label>

                        <app-text-radio-buttons
                            v-model="form[stepName].whenStart"
                            :breakMobile="true"
                            :items="whenStart"
                        >
                        </app-text-radio-buttons>
                    </div>

                    <div
                        v-if="form[stepName].whenStart == constants.custom"
                        class="form-group"
                    >
                        <app-label>{{ trans("select_start_date") }}</app-label>

                        <app-date-range-manual
                            v-model="form[stepName].startDate"
                            :disabled-dates="disabledDates"
                            :end-date="endDate"
                            :length-text="trans('insurance_length')"
                            :placeholder="trans('select_date')"
                            center
                            hide-range-text
                        >
                        </app-date-range-manual>
                    </div>
                </div>
            </div>

            <app-label v-if="form[stepName].whenStart">{{
                trans("coverage_type")
            }}</app-label>
            <div v-if="form[stepName].whenStart" class="form-row center">
                <!-- מקיף / צד ג -->
                <app-text-radio-buttons
                    v-model="form[stepName].optional"
                    :breakMobile="true"
                    :items="optionalInsurance"
                >
                </app-text-radio-buttons>
            </div>

            <div class="submit-row">
                <app-button :disabled="disabledConditions" :loading="loading">
                    {{ "quote.welcome.next" | __ }}
                </app-button>
            </div>
        </form>
    </div>
</template>

<script>
import moment from "moment";

import QuoteStep from "../../../mixins/QuoteStep";

export default {
    name: "CarQuoteSelectDate",

    mixins: [QuoteStep],

    props: {},

    data() {
        const date = new Date();
        const year = date.getFullYear();

        return {
            subSteps: ["default"],
            disabledDates: {
                to: new Date(year, date.getMonth(), date.getDate()),
                from: new Date(year + 1, date.getMonth(), date.getDate())
            }
        };
    },

    watch: {
        "form.CarQuoteSelectDate.whenStart": {
            deep: true,
            handler() {
                this.handleInsuranceStartDate();
            }
        }
    },

    methods: {
        handleInsuranceStartDate() {
            if (this.form[this.stepName].whenStart === this.constants.today) {
                this.form[this.stepName].startDate = moment().toDate();
            } else if (
                this.form[this.stepName].whenStart === this.constants.nextMonth
            ) {
                this.form[this.stepName].startDate = moment()
                    .set("D", 1)
                    .add(1, "M")
                    .toDate();
            } else {
                this.form[this.stepName].startDate = null;
            }
        }
    },

    computed: {
        optionalInsurance() {
            return [
                {
                    label: this.trans("types.com_mandatory"),
                    value: this.constants.OPTIONAL_COMPREHENSIVE
                },
                {
                    label: this.trans("types.3rd_mandatory"),
                    value: this.constants.OPTIONAL_THIRD_PARTY
                }
            ];
        },
        dateLengthText() {
            const length = this.trans("insurance_length");

            const startDate = moment(this.form[this.stepName].startDate);

            return length.replace(
                /\$/,
                this.endDate.diff(
                    startDate.set({
                        hour: 0,
                        minute: 0,
                        second: 0,
                        millisecond: 0
                    }),
                    "days"
                )
            );
        },
        endDate() {
            if (!this.stepFormFields.startDate) {
                return null;
            }

            return moment(this.stepFormFields.startDate)
                .add({ year: 1 })
                .endOf("month")
                .subtract({ month: 1 })
                .endOf("month")
                .set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
        },
        canMoveNext() {
            const mandatory = this.stepFormFields.mandatory;
            const optional = this.stepFormFields.optional;
            const possibleOptional = [
                this.constants.OPTIONAL_COMPREHENSIVE,
                this.constants.OPTIONAL_THIRD_PARTY
            ];

            return (
                this.stepFormFields.startDate &&
                mandatory &&
                possibleOptional.includes(optional)
            );
        },
        whenStart() {
            let months = {
                "01": "ינואר",
                "02": "פברואר",
                "03": "מרץ",
                "04": "אפריל",
                "05": "מאי",
                "06": "יוני",
                "07": "יולי",
                "08": "אוגוסט",
                "09": "ספטמבר",
                "10": "אוקטובר",
                "11": "נובמבר",
                "12": "דצמבר"
            };

            return [
                {
                    label: this.trans("from_today"),
                    value: this.constants.today
                },
                {
                    label:
                        "מ-1 ב" +
                        months[
                            moment(new Date())
                                .add({
                                    month: 1
                                })
                                .startOf("month")
                                .format("MM")
                        ],
                    value: this.constants.nextMonth
                },
                {
                    label: this.trans("different_date"),
                    value: this.constants.custom
                }
            ];
        }
    }
};
</script>

<style lang="scss" scoped>
.select-coverage {
    max-width: $quote-step-width;
}
.start-insurance-date {
    text-align: center;
    width: 100%;
}

.app-date-input {
    width: 100%;
    border-radius: 100px;
    border: 1px solid rgba(33, 67, 146, 0.2);
    background: $lightest-gray;

    input {
        font-size: 24px;
        height: 50px;
        margin: 0;

        @media all and (max-width: $mobile) {
            font-size: 21px;
        }
    }
}
</style>
